<script setup lang="ts">
import { defineProps, defineEmits, ref, watch } from 'vue';

const props = defineProps({
  modelValue: String,
});

const emits = defineEmits(['update:modelValue']);
const internalValue = ref(props.modelValue);

watch(
  () => props.modelValue,
  newValue => {
    internalValue.value = newValue;
  },
);
watch(
  () => internalValue.value,
  newValue => {
    emits('update:modelValue', newValue);
  },
);
</script>

<template>
  <v-radio-group
    class="radio-group"
    v-model="internalValue"
    inline
  >
    <v-radio
      :class="{ 'selected-radio': internalValue === '봉사내용' }"
      label="봉사내용"
      value="봉사내용"
    ></v-radio>
    <v-radio
      :class="{ 'selected-radio': internalValue === '신청결과' }"
      label="신청결과"
      value="신청결과"
    ></v-radio>
    <v-radio
      :class="{ 'selected-radio': internalValue === '기타' }"
      label="기타"
      value="기타"
    ></v-radio>
  </v-radio-group>
</template>

<style lang="scss" scoped>
.radio-group {
  width: 100%;
}
::v-deep .selected-radio .v-label {
  color: purple !important;
  font-weight: 800;
}
</style>
